import React from "react";
import { Timeline, Events, UrlButton, ImageEvent } from "@merc/react-timeline";
import "./ProjectsTimeLine.css";
import LightSpeed from "react-reveal/LightSpeed";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import { AnimationWrapper } from "react-hover-animation";

import roomBook from "../../assets/img/projects/roomBook.png";
import metro from "../../assets/img/projects/metro.jpg";
import chalDal from "../../assets/img/projects/chalDal.png";
import football from "../../assets/img/projects/football.jpg";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

// skills
import Firebase from "../../assets/img/skills/firebase.png";
import L_REACT from "../../assets/img/skills/react.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import Image from "react-bootstrap/Image";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_BOOTSTRAP4 from "../../assets/img/skills/bootstrap-4.svg";
import L_GIT from "../../assets/img/skills/github-api.svg";
import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";

const ProjectsTimeline = () => {
  return (
    <div id="projects">
      <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
      <Timeline>
        <LightSpeed>
          <Events>
            {/* Project: Todo List With MUI */}
            <LightSpeed right>
              <ImageEvent
                date="03/30/2021"
                className="text-center"
                text="Room Booking App"
                src={roomBook}
                alt="Room Booking App"
              >
                <div className="d-flex justify-content-between flex-column mt-1">
                  <div>
                    <Accordion>
                      <Card>
                        <Accordion.Toggle
                          as={Card.Header}
                          eventKey="0"
                          className="p-2 text-center accordian-main"
                        >
                          Click Here To See Details
                        </Accordion.Toggle>

                        <Accordion.Collapse eventKey="0" className="text-left">
                          <Card.Body>
                            <strong>Description:</strong> Built a Room Booking app using MERN Stack.
                            <hr />
                            <strong>Features:</strong>
                            <ul className="list-styles pt-1">
                              <li>
                                User can search and book rooms from anywhere.
                              </li>
                              <li>
                                Search rooms based on preferences. 
                              </li>
                              <li>
                                Register and login to check own booking information.
                              </li>
                              <li>
                                Admin can manage all the bookings, create new admin roles, add new rooms, delete existing rooms or update room price.
                              </li>
                              <li>
                                Email Subscription for offers and Discounts.
                              </li>
                            </ul>
                            <hr />
                            <strong>Tech used:</strong>
                            <ul>
                              <li>
                                <span className="p-2">
                                  <Image
                                    src={L_NODE_JS}
                                    alt="HTML 5"
                                    rounded
                                    className="image-style m-1"
                                  ></Image>{" "}
                                  NODE JS
                                </span>
                              </li>
                              <li>
                                <span className="p-2">
                                  <Image
                                    src={L_MONGODB}
                                    alt="CSS 3"
                                    rounded
                                    className="image-style m-1"
                                  ></Image>{" "}
                                  MongoDB
                                </span>
                              </li>
                              <li>
                                <span className="p-2">
                                  <Image
                                    src={L_REACT}
                                    alt="React"
                                    rounded
                                    className="image-style1 m-1"
                                  ></Image>{" "}
                                  React
                                </span>
                              </li>
                              <li>
                                <span className="p-2">
                                  <Image
                                    src={Firebase}
                                    alt="Material-UI"
                                    rounded
                                    className="image-style1 m-1"
                                  ></Image>{" "}
                                  Firebase
                                </span>
                              </li>
                              <li>
                                <span className="p-2">
                                  <Image
                                    src={L_EXPRESS}
                                    alt="Material-UI"
                                    rounded
                                    className="image-style1 m-1"
                                  ></Image>{" "}
                                  Express JS
                                </span>
                              </li>
                            </ul>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </div>
                  <div className="d-flex justify-content-between flex-nowrap text-center">
                    <UrlButton
                      href="https://room-hunt-f268f.web.app/"
                      target="_blank"
                    >
                      SEE LIVE
                    </UrlButton>
                    <UrlButton
                      href="https://github.com/hosainabid/room-hunt"
                      target="_blank"
                    >
                      CLIENT CODE
                    </UrlButton>
                    <UrlButton
                      href="https://github.com/hosainabid/room-hunt-server"
                      target="_blank"
                    >
                      SERVER CODE
                    </UrlButton>
                  </div>
                </div>
              </ImageEvent>
            </LightSpeed>

            {/* Project: MERN Tip Calculator */}
            <ImageEvent
              date="16/02/2021"
              className="text-center"
              text="Chal Dal Web App"
              src={chalDal}
              alt="Chal Dal Web App"
            >
              <div className="d-flex justify-content-between flex-column mt-1">
                <div>
                  <Accordion>
                    <Card>
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey="0"
                        className="p-2 text-center accordian-main"
                      >
                        Click Here To See Details
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="0" className="text-left">
                        <Card.Body>
                          <strong>Description:</strong> Built a MERN stack web
                          application with dynamic activities
                          <hr />
                          <strong>Features:</strong>
                          <ul className="list-styles pt-1">
                            <li>
                              A buyer can sign in with Google & can choose
                              products from the website.
                            </li>
                            <li>
                              Buyers can see their registration information in the dashboard. An admin can add new products
                              which will be visible in the activities section.
                            </li>
                            <li>
                              {" "}
                              An admin also can see the ordered list with
                              detailed information.
                            </li>
                          </ul>
                          <hr />
                          <strong>Tech used:</strong>
                          <ul>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_REACT}
                                  alt="React"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                React
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_NODE_JS}
                                  alt="Node.js"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                Node.js
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_MONGODB}
                                  alt="MongoDB"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                MongoDB
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_MATERIALUI}
                                  alt="Material-UI"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                Material-UI
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_CSS3}
                                  alt="Material-UI"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                CSS
                              </span>
                            </li>
                          </ul>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
                <div className="d-flex justify-content-between flex-nowrap text-center">
                  <UrlButton
                    href="https://chal-dal-bcccb.web.app/"
                    target="_blank"
                  >
                    See Live
                  </UrlButton>
                  <UrlButton
                      href="https://github.com/hosainabid/chal-dal-client"
                      target="_blank"
                    >
                      CLIENT CODE
                    </UrlButton>
                    
                    <UrlButton
                      href="https://github.com/hosainabid/chal-dal-app"
                      target="_blank"
                    >
                      SERVER CODE
                    </UrlButton>
                  
                </div>
              </div>
            </ImageEvent>

            {/* Project: Get GitHub Info */}
            <ImageEvent
              date="19/03/2021"
              className="text-center"
              text="Dhaka Metro Rail"
              src={metro}
              alt="Dhaka Metro Rail"
            >
              <div className="d-flex justify-content-between flex-column mt-1">
                <div>
                  <Accordion>
                    <Card>
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey="0"
                        className="p-2 text-center accordian-main"
                      >
                        Click Here To See Details
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="0" className="text-left">
                        <Card.Body>
                          <strong>Description:</strong> Built a MERN stack web
                          application with dynamic activities.
                          <hr />
                          <strong>Features:</strong>
                          <ul className="list-styles pt-1">
                            <li>It was a metro railway ticket web app.</li>
                            <li>
                              {" "}
                              Buyers can purchase ticket from here. They can
                              select and see their destination in this website{" "}
                            </li>
                            <li>
                              {" "}
                              It also authenticated by firebase. Buyer can see
                              the maps from where they have to go
                            </li>
                          </ul>
                          <hr />
                          <strong>Tech used:</strong>
                          <ul>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_HTML5}
                                  alt="HTML 5"
                                  rounded
                                  className="image-style m-1"
                                ></Image>{" "}
                                HTML5
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_CSS3}
                                  alt="CSS 3"
                                  rounded
                                  className="image-style m-1"
                                ></Image>{" "}
                                CSS3
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_REACT}
                                  alt="React"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                React
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_GIT}
                                  alt="Github API"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                GitHub API
                              </span>
                            </li>
                          </ul>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
                <div className="d-flex justify-content-between flex-nowrap text-center">
                  <UrlButton
                    href="https://dhaka-metro-rail.web.app/"
                    target="_blank"
                  >
                    SEE LIVE
                  </UrlButton>
                  <UrlButton
                      href="https://github.com/hosainabid/metro-rail"
                      target="_blank"
                    >
                      SOURCE CODE
                    </UrlButton>
                </div>
              </div>
            </ImageEvent>

            {/* Project: Smart Brain */}
            <ImageEvent
              date="21/01/2021"
              className="text-center"
              text="English Premier League"
              src={football}
              alt="English Premier League"
            >
              <div className="d-flex justify-content-between flex-column mt-1">
                <div>
                  <Accordion>
                    <Card>
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey="0"
                        className="p-2 text-center accordian-main"
                      >
                        Click Here To See Details
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="0" className="text-left">
                        <Card.Body>
                          <strong>Description:</strong> A web app that shows all the team information in a football league through API.
                          <hr />
                          <strong>Features:</strong>
                          <ul className="list-styles pt-1">
                            <li>Uses Sports API from a Website</li>
                            <li>Shows all the club information in a league</li>
                            <li>Shows stadium and team details from API</li>
                          </ul>
                          <hr />
                          <strong>Tech used:</strong>
                          <ul>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_REACT}
                                  alt="React"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                React
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_JAVASCRIPT}
                                  alt="Node.js"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                JavaScript
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_HTML5}
                                  alt="Express"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                HTML5
                              </span>
                            </li>
                            <li>
                              <span className="p-2">
                                <Image
                                  src={L_BOOTSTRAP4}
                                  alt="PostgreSQL"
                                  rounded
                                  className="image-style1 m-1"
                                ></Image>{" "}
                                Bootstrap
                              </span>
                            </li>
                          </ul>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
                <div className="d-flex justify-content-between flex-nowrap text-center">
                  <UrlButton
                    href="https://english-league.netlify.app/"
                    target="_blank"
                  >
                    SEE LIVE
                  </UrlButton>
                </div>
              </div>
            </ImageEvent>

            {/* Project: RoboFriends */}
          </Events>
        </LightSpeed>
      </Timeline>
    </div>
  );
};

export default ProjectsTimeline;
